import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import API from "../api/api";
import "./MainCategoryPage.css";

const MainCategoryPage = () => {
  const { mainCategory } = useParams();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, [mainCategory]);

  const loadData = async () => {
    try {
      const res = await API.get("/schemes");
      const allSchemes = res.data;

      // 1️⃣ find matching visible scheme
      const matched = allSchemes.find(
        (s) =>
          s.mainCategory.toLowerCase() === mainCategory.toLowerCase() &&
          s.showInSchemeList === true
      );

      if (!matched) {
        setCategories([]);
        setLoading(false);
        return;
      }

      // 2️⃣ filter visible categories
      const visibleCategories = (matched.categories || [])
        .filter((cat) => cat.showInSchemeList === true)
        .map((cat) => ({
          ...cat,
          // 3️⃣ include only visible subcategories
          subcategories: (cat.subcategories || []).filter(
            (sub) => sub.showInSchemeList === true
          )
        }));

      setCategories(visibleCategories);
    } catch (err) {
      console.error("Error loading main category:", err);
    }

    setLoading(false);
  };

  if (loading)
    return (
      <div className="text-center mt-5 fw-bold fs-4 text-primary">
        Loading...
      </div>
    );

  return (
    <div className="container mt-4 mb-5">
      <h2 className="page-title fw-bold text-center mb-4">
        {mainCategory}
      </h2>

      <div className="row g-4">
        {categories.map((cat, i) => (
          <div key={i} className="col-md-4 col-sm-6 col-12">
            <div className="card shadow-sm category-card h-100">
              <div className="card-body">
                <h5 className="category-title">
                  <Link
                    to={`/category/${encodeURIComponent(cat.name)}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {cat.name}
                  </Link>
                </h5>

                <p className="category-subcount">
                  {cat.subcategories.length} Subcategories
                </p>

                <div className="text-center mt-2">
                  <Link
                    to={`/category/${encodeURIComponent(cat.name)}`}
                    className="btn btn-view-all"
                  >
                    View All →
                  </Link>
                </div>

              </div>
            </div>
          </div>
        ))}
      </div>

      {categories.length === 0 && (
        <p className="text-center text-muted mt-4">
          No visible categories for this main category.
        </p>
      )}
    </div>
  );
};

export default MainCategoryPage;
